import React from "react";

import { Filter, ReferenceArrayInput, SelectInput, SelectArrayInput, AutoCompleteArrayInput } from "jazasoft";

import { getStateChoices } from "../constants";

const inputOptions = {
  xs: 12,
  fullWidth: true,
  options: { fullWidth: true }
};

const filters = (withState = true, productList = [], unitChoices = []) => (
  <Filter>
    {withState && <SelectInput label="Order Status" source="state" choices={getStateChoices()} {...inputOptions} />}
    {unitChoices?.length > 2 && <SelectInput source="unitId" choices={unitChoices} {...inputOptions} />}
    <SelectInput label="Products" source="productName" choices={productList.map(p => ({ id: p.name, name: p.name }))} {...inputOptions} />
    <ReferenceArrayInput
      label="Season"
      resource="seasons"
      source="seasonId"
      reference="seasons"
      pageSize={100}
      sort={{ field: "name", order: "asc" }}
      {...inputOptions}>
      <SelectArrayInput />
    </ReferenceArrayInput>
    <ReferenceArrayInput
      label="Customer"
      resource="customers"
      source="customerId"
      reference="customers"
      sort={{ field: "name", order: "asc" }}
      {...inputOptions}>
      <AutoCompleteArrayInput disablePortal={true} />
    </ReferenceArrayInput>
  </Filter>
);
export default filters;
